let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j5W60")).then(() => parcelRequire('ju9Zq'));